import Component from '../abstracts/Component';
import {
  toggleTabIndex
} from "../utils/FocusableElementUtils";

export default class SearchComponent extends Component {

  get SELECTORS() {
    return {
      main: '[data-search]:not(.search-header)',
      searchClose: '.js-search-hide',
      searchSubmit: '.js-search-submit',
      searchInput: '.js-search-input',
      searchForm: '.search-wrapper form',
      searchHeader: '.search-header-wrapper'
    };
  }

  get CLASSES() {
    return {
      visible: 'is-visible',
      translate: 'translate-search'
    };
  }

  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
    this.searchForm = $(this.SELECTORS.searchForm);
    this.searchInput = $(this.SELECTORS.searchInput);
    this.searchSubmit = $(this.SELECTORS.searchSubmit);
    this.searchShow = $(this.SELECTORS.main).data('searchShow');
    this.hideSearch = $(this.SELECTORS.main).data('searchHide');
    this.searchHeader = $(this.SELECTORS.searchHeader);
    this.lastScrollTop = 0;
  }

  isVisible() {
    let isVisible = this.main.hasClass(this.CLASSES.visible);

    if (isVisible) {
      // disattivo il pulsanete di ricerca dal menu
      $(this.searchShow).addClass('not-visible');
      // aggiungo la classe al main 'search-visible'
      this.$emit(this.$customEvents.SEARCH_EVENTS.visible);
      if (!this.main.hasClass('page-search')) {
        // se non sono nella pagina di ricerca do il focus all'input field e attivo il backdrop
        $(this.main).find('input').focus();
        this.$emit(this.$customEvents.BACKDROP_EVENTS.show, {
          classes: 'dark'
        });
      }
      // gestisco l'evento del click sul pulsante chiudi
      this.$on('click.search', () => {
        this.close();
      }, this.hideSearch);
    } else {
      this.main.attr('tabindex', -1);
      toggleTabIndex(this.main, false);
    }
  }

  close() {
    this.main.attr('aria-hidden', true);
    this.main.attr('tabindex', -1);
    toggleTabIndex(this.main, false);
    // attivo il pulsanete di ricerca dal menu
    $(this.searchShow).removeClass('not-visible');
    // chiudo la search bar
    this.main.removeClass(this.CLASSES.visible);
    // rimuovo la classe al main 'search-visible'
    this.$emit(this.$customEvents.SEARCH_EVENTS.hidden);
    if (!this.main.hasClass('page-search')) {
      this.$emit(this.$customEvents.BACKDROP_EVENTS.hide, {
        classes: 'dark'
      });
    }
  }

  toggleSearchButton() {
    if (this.searchSubmit.hasClass('icon-close')) {
      this.searchInput.val('');
      this.searchSubmit.removeClass('icon-close');
      this.searchSubmit.addClass('icon-sldierwithoutcircle');
    }
  }

  inputChange() {
    const layerSearch = document.querySelector(this.SELECTORS.main);

    if (!layerSearch) return;
    const input = layerSearch.querySelector(layerSearch.dataset.searchInput);
    const button = layerSearch.querySelector(layerSearch.dataset.searchSubmit);

    this.$on('keyup.search', ({
      event
    }) => {
      if (event.currentTarget.value.trim() === '') {
        button.setAttribute('disabled', 'disabled');
      } else {
        button.removeAttribute('disabled');
        button.classList.remove('icon-close');
        button.classList.add('icon-sldierwithoutcircle');
      }
    }, input)
  }

  pageScrolled() {
    var scrolled = window.pageYOffset || document.documentElement.scrollTop;

    // console.log('%c scrolled: ', 'color:red;', scrolled)
    // console.log('%c lastscroll: ', 'color:green;', this.lastScrollTop);

    if ((scrolled > this.lastScrollTop) || scrolled == 0) {
      // upscroll code
      if (this.searchHeader.hasClass(this.CLASSES.translate)) {
        this.searchHeader.removeClass(this.CLASSES.translate);
      }
    } else {
      // downscroll code
      if (!this.searchHeader.hasClass(this.CLASSES.translate)) {
        this.searchHeader.addClass(this.CLASSES.translate);
      }
    }

    this.lastScrollTop = scrolled <= 0 ? 0 : scrolled;
  }

  bindGenericEvents() {
    // check sulla submit del form
    $(document).on('submit', this.SELECTORS.searchForm, (event) => {
      if (this.searchSubmit.hasClass('icon-close')) {
        event.preventDefault();
        this.searchSubmit.attr('disabled', 'disabled')
        this.toggleSearchButton();
      }
    });

    this.inputChange();
    this.isVisible();

    if (document.body.classList.contains('t-search')) {
      this.pageScrolled();
      this.$on('scroll', () => {
        this.pageScrolled();
      });
    } else {
      // click burger menu close search
      this.$on(this.$customEvents.BURGER_EVENTS.click, ({
        payload
      }) => {
        if (payload.menuIn && this.main.hasClass(this.CLASSES.visible)) {
          this.close();
        }
      });

      // click sul pulsamnte di ricerca
      this.$on('click.search', () => {
          this.main.attr('tabindex', '');
          this.main.attr('aria-hidden', !this.main.attr('aria-hidden'));
          toggleTabIndex(this.main, true);
          this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.show);

          this.main.addClass(this.CLASSES.visible);
          this.isVisible();
      }, this.searchShow);
    }
  }

  render() {
    if (this.main.length === 0) return;
    this.bindGenericEvents();
  }
}
